import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {CategorieDemat} from "../../../../../models/formdemat.model";


@Component({
  selector: 'app-modal-categorie',
  templateUrl: './modal-categorie.component.html',
  styleUrls: ['./modal-categorie.component.scss']
})
export class ModalCategorieComponent {
  item: CategorieDemat;
  mode: string;
  confirmButtonText = 'Valider';
  cancelButtonText = 'Annuler';

  readonly titreMaxLen = 80;
  readonly descriptionMaxLen = 250;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ModalCategorieComponent>
  ) {
    this.mode = data?.mode;
    this.item = data?.cat || {
      name: '',
      description: '',
      active: true
    };

    if (data?.buttonText) {
      this.confirmButtonText = data.buttonText.ok || this.confirmButtonText;
    }
  }

  onCloseClick(): void {
    this.dialogRef.close(this.item);
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }
}
